import AWS from "aws-sdk";
import { CookieStorage, CognitoUserPool } from "amazon-cognito-identity-js";
import config from "../config";

export async function invokeApig({
  app = "fleet",
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  body
}) {
  if (!await authUser()) {
    throw new Error("User is not logged in");
  }

  body = body ? JSON.stringify(body) : body;

  const currentUser = getCurrentUser();
  if (currentUser === null) {
    return false;
  }
  const userToken = await getUserToken(currentUser);
  const url = `${config.apiGateway.URL}/${app}${path}`;
  headers["Authorization"] = userToken;
  headers["content-type"] = "application/json";
  const results = await fetch(url, {
    method,
    headers,
    body
  });

  if (results.status !== 200) {
    throw new Error(await results.text());
  }

  return results.json();
}

export async function invokePublicApig({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  body
}) {
  body = body ? JSON.stringify(body) : body;

  const url = config.apiGateway.URL + path;
  headers["content-type"] = "application/json";
  const results = await fetch(url, {
    method,
    headers,
    body
  });

  if (results.status !== 200) {
    throw new Error(await results.text());
  }

  return results.json();
}

export async function s3Upload(file, params) {
  if (!await authUser()) {
    throw new Error("Debes estar autenticado");
  }

  const s3 = new AWS.S3({
    params: {
      Bucket: config.s3.BUCKET
    }
  });
  const filename = `${params.folder}/${params.name}`;

  return s3
    .upload({
      Key: filename,
      Body: file,
      ContentType: file.type,
      ACL: "public-read"
    })
    .promise();
}

export async function authUser() {
  if (
    AWS.config.credentials &&
    Date.now() < AWS.config.credentials.expireTime - 60000
  ) {
    return true;
  }

  const currentUser = getCurrentUser();

  if (currentUser === null) {
    return false;
  }

  const userToken = await getUserToken(currentUser);

  await getAwsCredentials(userToken);

  return true;
}

export function signOutUser() {
  const currentUser = getCurrentUser();

  if (currentUser !== null) {
    currentUser.signOut();
  }

  if (AWS.config.credentials) {
    AWS.config.credentials.clearCachedId();
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({});
  }
}

function getUserToken(currentUser) {
  return new Promise((resolve, reject) => {
    currentUser.getSession(function(err, session) {
      if (err) {
        reject(err);
        return;
      }
      resolve(session.getIdToken().getJwtToken());
    });
  });
}

function getCurrentUser() {
  const userPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID,
    Storage: new CookieStorage({domain: config.domain, secure: config.domain_secure})
  });
  return userPool.getCurrentUser();
}

function getAwsCredentials(userToken) {
  const authenticator = `cognito-idp.${config.cognito
    .REGION}.amazonaws.com/${config.cognito.USER_POOL_ID}`;

  AWS.config.update({ region: config.cognito.REGION });

  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: config.cognito.IDENTITY_POOL_ID,
    Logins: {
      [authenticator]: userToken
    }
  });

  return AWS.config.credentials.getPromise();
}

export function getAccessToken() {
  const currentUser = getCurrentUser();
  if (currentUser === null) {
	return false;
  }
  return new Promise((resolve, reject) => {
    currentUser.getSession(function(err, session) {
      if (err) {
        reject(err);
        return;
      }
      resolve(session.getAccessToken().getJwtToken());
    });
  });
}

export function getUserAttributes() {
  const currentUser = getCurrentUser();
  if (currentUser === null) {
	   return false;
  }
  return new Promise((resolve, reject) => {
    currentUser.getSession(function(err, session) {
      if (err) {
        reject(err);
        return;
      }
      resolve(session.getIdToken().payload);
    });
  });
}



// WEBPACK FOOTER //
// ./src/libs/awsLib.js